import script from "./CreateAttributeDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateAttributeDialog.vue?vue&type=script&setup=true&lang=js"

import "./CreateAttributeDialog.vue?vue&type=style&index=0&id=1404dea6&lang=css"
import "./CreateAttributeDialog.vue?vue&type=style&index=1&id=1404dea6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1404dea6"]])

export default __exports__